import { message, Modal, Spin } from "antd";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import download from "downloadjs";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";
import { useTranslation } from "react-i18next";

const StyledDocumentModal = styled(Modal)`
  max-width: 90vw;
  width: 100%;
  top: 0;
  padding: 0;

  .ant-modal-content {
    height: 95vh;
    padding: 10px;
  }

  .pdf-viewer {
    width: 100%;
    height: 85vh;
    border: none;
  }

  @media (max-width: 768px) {
    .ant-modal-content {
      height: 100vh;
    }
    .pdf-viewer {
      height: 75vh;
    }
  }
`;

const ViewDocument = ({ open, onCancel, data }) => {
  const { t } = useTranslation();
  const userInfo = useSelector(getUserInfo);
  const [loading, setLoading] = useState(false);
  const [previewURL, setPreviewURL] = useState("");

  return (
    <StyledDocumentModal
      centered
      open={open}
      footer={null}
      onCancel={() => onCancel(false)}
      width={900}
    >
      <Spin spinning={loading}>
        {data ? (
          <embed src={data} title={t("Document")} className="pdf-viewer" />
        ) : (
          !loading && (
            <p style={{ textAlign: "center" }}>{t("No preview available")}</p>
          )
        )}
      </Spin>
    </StyledDocumentModal>
  );
};

export default ViewDocument;
